import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import reportWebVitals from './reportWebVitals';
import { ymEvent, giEvent } from "./app/utils/metrix";
import { AppWrap } from "./AppWrap";



document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.wrapper')!;
  const startBtn = document.getElementById('startPlay')!;
  const root = createRoot(container);
  startBtn.addEventListener('click', (e) => {
    e.preventDefault()
    giEvent('RED_Krug')
    ymEvent('open_game_circle_click')
    const htmlElement = document.querySelector('html')
    htmlElement?.classList.add('megazavod')
    container.classList.add('mega-clicker-root')
    container.classList.remove('wrapper')

    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <AppWrap/>
        </Provider>
      </React.StrictMode>
    );

  })
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
